import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { Observable, empty, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const headers: { [name: string]: string | string[]; } = {};
    for (const key of request.headers.keys()) {
      headers[key] = request.headers.getAll(key);
    }

    let token = localStorage.getItem('token');

    if (token) {

      headers['Authorization'] = 'Bearer ' + token;
    }

    var newRequest = request.clone({
      headers: new HttpHeaders(headers)
    })

    return next.handle(newRequest).pipe(
      tap(res => {
        if (res instanceof HttpResponse) {
          token = res.headers.get('token')
          if (token) {
            localStorage.setItem('token', token);
          }
        }
      }),
      catchError((err, caught) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status == 401) {
            this.router.navigate(['login']);
            localStorage.removeItem('token');
            localStorage.removeItem('userinfo');
            localStorage.removeItem('permissions');
            return empty();
          }
        }
        return throwError(err);
      })
    )
  }
}
